import { useFlagOverrides } from "./use-flag-overrides.js";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";

//#region src/client/use-flags.ts
/**
* This hook should not be used directly in most cases as each consumer should
* wrap this hook with associated type and useOverrides logic. It has been
* marked deprecated to make clear that it should not be imported directly in
* most contexts.
* @internal
* @deprecated
*/
const useFlags$1 = (useOverrides = true) => {
	const ldFlags = useFlags();
	const { overriddenFlags } = useFlagOverrides();
	return useMemo(() => {
		if (useOverrides) return {
			...ldFlags,
			...overriddenFlags
		};
		return ldFlags;
	}, [
		ldFlags,
		overriddenFlags,
		useOverrides
	]);
};

//#endregion
export { useFlags$1 as useFlags };